<script setup lang="ts">
import { computed, type ComputedRef } from 'vue';
import { useRoute } from 'vue-router';
import useBreadcrumbStore, {
  type BreadcrumbItem,
} from '@/store/BreadcrumbStore';

const route = useRoute();
const breadcrumbStore = useBreadcrumbStore();

const items: ComputedRef<BreadcrumbItem[]> = computed(() => {
  const staticItems = route.meta.breadcrumb?.() ?? [];
  const allItems = [...staticItems, ...breadcrumbStore.dynamicItems];
  return allItems.map((item, index) => ({
    ...item,
    disabled: item.disabled || index === allItems.length - 1 || !item.to,
  }));
});
</script>

<template>
  <div v-if="items.length > 0" class="app-breadcrumbs d-flex align-center">
    <v-icon
      class="app-breadcrumbs-divider"
      icon="mdi-chevron-right"
      size="small"
    />
    <v-breadcrumbs :items="items" density="compact">
      <template v-slot:divider>
        <v-icon
          class="app-breadcrumbs-divider"
          icon="mdi-chevron-right"
          size="small"
        />
      </template>
    </v-breadcrumbs>
    <v-menu v-if="breadcrumbStore.actions.length > 0" location="bottom start">
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          icon="mdi-dots-horizontal"
          variant="text"
          size="small"
          :aria-label="$gettext('More actions')"
        />
      </template>
      <v-list density="compact" min-width="240">
        <v-list-item
          v-for="action in breadcrumbStore.actions"
          :key="action.title"
          :prepend-icon="action.icon"
          :title="action.title"
          @click="action.handler"
        />
      </v-list>
    </v-menu>
  </div>
</template>

<style scoped lang="scss">
.app-breadcrumbs {
  flex-wrap: nowrap;
  white-space: nowrap;
  margin-left: 12px;

  .app-breadcrumbs-divider {
    opacity: 0.45;
  }

  :deep(.v-breadcrumbs-item--disabled) {
    opacity: 1;
    font-weight: 500;
    background: rgba(var(--v-theme-on-surface), 0.06);
    border-radius: 8px;
    padding: 4px 12px;
  }
}
</style>
